const EntradaSalidaOptions = [
  {
    label: "Selecciona",
    value: '',
  },
  {
  label: "Entrada",
  value: "Entrada",
  },
  {
  label: "Salida",
  value: "Salida",
  }
];

export default EntradaSalidaOptions;